import { render, staticRenderFns } from "./CompanyUserDetailScreen.vue?vue&type=template&id=ae17f6b0&scoped=true&lang=pug"
import script from "./CompanyUserDetailScreen.vue?vue&type=script&lang=ts"
export * from "./CompanyUserDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./CompanyUserDetailScreen.vue?vue&type=style&index=0&id=ae17f6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae17f6b0",
  null
  
)

export default component.exports